import Cookies from "js-cookie";
import { GAClientId } from "Types/state";

const clientIdIsValid = (clientId: any): boolean => {
    return typeof clientId === "string" && clientId.length > 2;
};

const getGAClientIdFromWindow = (): GAClientId => {
    const windowGAGetAllResults =
        (window as any).ga && typeof (window as any).ga.getAll === "function" && (window as any).ga.getAll();
    const windowGAClientId =
        windowGAGetAllResults &&
        windowGAGetAllResults[0] &&
        windowGAGetAllResults[0].get &&
        windowGAGetAllResults[0].get("clientId");
    return windowGAClientId || "";
};

function getGoogleAnalyticsClientId(): GAClientId {
    let clientId = getGAClientIdFromWindow();

    if (!clientIdIsValid(clientId)) {
        clientId = getGAClientIdFromCookie();
    }

    return clientIdIsValid(clientId) ? clientId : "";
}

const getGAClientIdFromCookie = (): string => {
    const cookie = Cookies.get("_ga");
    if (!cookie) return "";

    const gaCookieData = cookie.split(".");
    if (gaCookieData.length < 4 || gaCookieData.includes("")) return "";

    return `${gaCookieData[2]}.${gaCookieData[3]}`;
};

export { clientIdIsValid, getGoogleAnalyticsClientId, getGAClientIdFromWindow };
